'use strict';

require('./insights.js');

